import { Component } from '@angular/core';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { BackgroundDecorationComponent } from '../shared-components/background-decoration/background-decoration.component';
@Component({
  selector: 'app-page-not-allowed',
  imports: [BackgroundDecorationComponent, SharedComponentsModule],
  templateUrl: './page-not-allowed.component.html',
  styleUrl: './page-not-allowed.component.scss',
  standalone: true,
})
export class PageNotAllowedComponent {}
